import React from 'react';
import { node, shape, string } from 'prop-types';

import Wrapper from '../Wrapper';
import Row from '../Container/Row';
import { SubBodyText } from '../Text/Heading';
import RawHTML from '../RawHTML';

const DescriptionItem = ({ label, content, classNames, ...restProps }) => (
  <Wrapper marginTop="8px" {...restProps}>
    <Row>
      <SubBodyText
        fontWeight="500"
        color="greyDarker"
        className={classNames.label}
      >
        {label}
      </SubBodyText>
    </Row>
    <SubBodyText color="greyDark" className={classNames.content}>
      <RawHTML>{content}</RawHTML>
    </SubBodyText>
  </Wrapper>
);

DescriptionItem.propTypes = {
  label: node,
  content: node,
  classNames: shape({
    label: string.isRequired,
    content: string.isRequired,
  }),
};
DescriptionItem.defaultProps = {
  classNames: { label: '', content: '' },
};

export default DescriptionItem;
